export enum CurrencyId {
  AUD = 36,
  CAD = 124,
  CNY = 156,
  CZK = 203,
  HKD = 344,
  INR = 356,
  JPY = 392,
  RUB = 643,
  SGD = 702,
  SZL = 748,
  CHF = 756,
  GBP = 826,
  USD = 840,
  EUR = 978,
  UAH = 980,
  BRL = 986,
}

export type Currency = 'AUD' |
'BRL' |
'CAD' |
'CHF' |
'CNY' |
'CZK' |
'EUR' |
'GBP' |
'HKD' |
'INR' |
'JPY' |
'RUB' |
'SGD' |
'SZL' |
'UAH' |
'USD';
